import { BucketItem, FiltersApiResponse } from "@/components/PageAllResources/api/interface";

export enum FILTER_RESOURCE_TYPE {
  articles = "Articles",
  video = "Videos",
}

export const getFilterName: (urlFilter: any, filters: FiltersApiResponse) => string = (urlFilter, filters) => {
  if (urlFilter?.length) {
    const filterKey = urlFilter?.[0];
    const filterValue = urlFilter[1]?.[0];
    const filterObject = Object.entries(filters)?.find(([_, value]: [string, BucketItem[]]) => {
      return value?.[0]?.urlKey === filterKey;
    });

    const filter = filterObject?.[1].find(({ slug }) => slug === filterValue);

    return filter?.key;
  }

  return "";
};

export const getAppliedFilters = (searchParams: any, urlFilter: any) => {
  try {
    const entries = urlFilter
      ? Object.entries({ [urlFilter?.[0]]: urlFilter?.[1]?.[0] })
      : Object.entries(Object.fromEntries(searchParams));

    return Object.fromEntries(entries?.map(([key, value]: any) => [key, value.split(",")]) || []);
  } catch (e) {
    console.error({ e });

    return {};
  }
};

export interface searchParamsResponse {
  singleFilter: boolean;
  searchParams: any;
  appliedFilters: [string, string[]][];
}

export const convertToSearchParams: (filters: any) => searchParamsResponse = (filters: any) => {
  const entries: any = Object.entries(filters)?.filter(
    ([_, value]: [string, string[]]) => !!value?.length && !!value?.filter((v) => !!v)?.length
  );

  const searchParams = new URLSearchParams(entries);

  const singleFilter = entries?.length == 1 && entries[0]?.[1]?.length == 1;

  return {
    singleFilter,
    searchParams,
    appliedFilters: entries,
  };
};
